import { render, staticRenderFns } from "./NetworkTypePage.vue?vue&type=template&id=00b8069e"
import script from "./NetworkTypePage.vue?vue&type=script&lang=js"
export * from "./NetworkTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports